import { ReactElement } from 'react';
import cc from 'classcat';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const FavoriteCasinoProviderCardSkeleton = (): ReactElement => {
  return (
    <div className="favoritesCasinoProviders__provider">
      <Skeleton
        active
        title={{
          width: '35px',
          style: { height: 35, margin: 10 }
        }}
        paragraph={false}
        className="matchHeader__skeleton"
      />
      <Skeleton
        active
        title={{ width: 276, style: { height: 175 } }}
        paragraph={false}
        className={cc([
          'matchHeader__skeleton providerRightImage__skeleton',
          {
            'providerRightImage__skeleton--rtl': SpringConfigs.IS_RTL
          }
        ])}
      />
      <Skeleton
        active
        title={{ width: '40%', style: { height: 20 } }}
        paragraph={false}
        className="matchHeader__skeleton"
      />
    </div>
  );
};
